//Action creator with callback function
export function setPageCampaignDetails(pageCampaignDetails) {
    return dispatch => {
        return new Promise(function (resolve, reject) {
            dispatch({
                type: 'SET_PAGE_CAMPAIGN_DATA',
                payload: pageCampaignDetails
            });
            resolve(true)
        });
    }
};

export const resetPageCampaignDetails = () => ({
    type: 'RESET_PAGE_CAMPAIGN_DATA'
});